import { Grid } from "@material-ui/core";
import { SelectIcon } from "App/Assets";
import {
  InputTextMaster,
  InputOptionMaster,
  MasterButton,
  InputCheckboxMaster,
} from "App/Component/ui";
import { isNull } from "App/utils/helpers";
import { pembiayaanDanPenanggungJawab } from "../constants";
import { useKelasRawat } from "../hooks";
import React from "react";

export const FormHanyaJikaRawatInap = ({
  formData,
  setFormData,
  type,
  handleChange,
  handleClickNoKontrol,
  handleClickNoRujukan,
}) => {
  // const { kodeFaskes, loadingFaskes } = useFaskes(formData.ppk_rujukan_search);
  const kelasRawat = useKelasRawat();

  if (type === "RI") {
    return (
      <>
        <Grid item sm={4}>
          <InputTextMaster
            name='tgl_rujukan'
            label='TGL RUJUKAN'
            id='tgl_rujukan'
            type='date'
            onChange={handleChange("tgl_rujukan")}
            value={formData.tgl_rujukan}
            placeholder=''
          />
        </Grid>

        {/* <Grid item sm={2}>
          <div className='mt-2'>
            <InputCheckboxMaster
              checked={formData.is_bayi}
              name='is_bayi'
              id='is_bayi'
              label='Bayi'
              onChange={() =>
                setFormData({
                  ...formData,
                  is_bayi: !formData.is_bayi,
                })
              }
            />
          </div>
        </Grid> */}

        {isNull(formData.no_sep) || formData.no_sep === "-" ? (
          <>
            {/* <Grid item sm={4}>
              <InputTextMaster
                name='ppk_rujukan_kode'
                label='KODE PPK RUJUKAN'
                id='ppk_rujukan_kode'
                value={formData.ppk_rujukan_kode}
                disabled={true}
                readOnly={true}
                // onChange={handleChange("ppk_rujukan_kode")}
                placeholder=''
              />
            </Grid> */}
            <Grid item sm={4}>
              <InputTextMaster
                name='ppk_rujukan_name'
                label='PPK RUJUKAN'
                id='ppk_rujukan_name'
                value={formData.ppk_rujukan_name}
                disabled={true}
                readOnly={true}
                // onChange={handleChange("ppk_rujukan_kode")}
                placeholder=''
              />
            </Grid>
          </>
        ) : (
          <>
            {" "}
            <Grid item sm={4}>
              <InputTextMaster
                name='ppk_rujukan_name'
                label='PPK RUJUKAN'
                id='ppk_rujukan_name'
                value={formData.ppk_rujukan_name}
                onChange={handleChange("ppk_rujukan_name")}
                placeholder=''
                readOnly={true}
                disabled={true}
              />
            </Grid>{" "}
          </>
        )}

        <Grid item sm={4}>
          {formData.is_bayi ? (
            <>
              <InputTextMaster
                name='no_rujukan'
                label='NO RUJUKAN (SEP ASAL IBU)'
                id='no_rujukan'
                placeholder='No Rujukan'
                value={formData.no_rujukan}
                onChange={handleChange("no_rujukan")}
              />
            </>
          ) : (
            <div
              style={{
                display: "flex",
              }}>
              <InputTextMaster
                name='no_rujukan'
                label='NO RUJUKAN'
                id='no_rujukan'
                placeholder='No Rujukan'
                value={formData.no_rujukan}
                onChange={handleChange("no_rujukan")}
              />

              <MasterButton
                type={"button"}
                color='lightgreen'
                name=''
                size='sm'
                withIcon={true}
                onClick={handleClickNoRujukan}
                style={{
                  marginTop: "1.5rem",
                  width: "32px",
                  height: "32px",
                }}
                icon={
                  <SelectIcon
                    width='16px'
                    height='16px'
                    style={{
                      marginLeft: "-0.5rem",
                    }}
                  />
                }
              />
            </div>
          )}
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name='hak_kelas'
            label='HAK KELAS'
            id='hak_kelas'
            readOnly={true}
            disabled={true}
            value={formData.hak_kelas}
            onChange={handleChange("hak_kelas")}
            placeholder=''
          />
        </Grid>

        <Grid item sm={4}>
          <InputOptionMaster
            name='kls_rawat_naik'
            label='KELAS RAWAT NAIK'
            id='kls_rawat_naik'
            value={formData.kls_rawat_naik}
            withSearch={true}
            labelValue={formData.kls_rawat_naik_name}
            onChange={(e) => {
              if (isNull(e)) {
                setFormData({
                  ...formData,
                  kls_rawat_naik: null,
                  kls_rawat_naik_name: "Pilih Kelas Rawat",
                });
              } else {
                setFormData({
                  ...formData,
                  kls_rawat_naik: e.value,
                  kls_rawat_naik_name: e.label,
                });
              }
            }}
            data={kelasRawat}
          />
        </Grid>

        <Grid item xs={4}>
          <div
            style={{
              display: "flex",
            }}>
            <InputTextMaster
              name='nokontrol'
              label='NO SPRI'
              id='nokontrol'
              placeholder='No SPRI'
              value={formData.nokontrol}
              onChange={handleChange("nokontrol")}
            />

            <MasterButton
              type={"button"}
              color='lightgreen'
              name=''
              size='sm'
              withIcon={true}
              onClick={handleClickNoKontrol}
              style={{
                marginTop: "1.5rem",
                width: "32px",
                height: "32px",
              }}
              icon={
                <SelectIcon
                  width='16px'
                  height='16px'
                  style={{
                    marginLeft: "-0.5rem",
                  }}
                />
              }
            />
          </div>
        </Grid>

        <Grid item sm={4}>
          <InputTextMaster
            name='kode_dpjp_dokter'
            label='DPJP'
            id='kode_dpjp_dokter'
            readOnly={true}
            disabled={true}
            value={formData.kode_dpjp_dokter}
            // onChange={handleChange("kode_dpjp_dokter")}
            placeholder=''
          />
        </Grid>

        {!isNull(formData.kls_rawat_naik) && (
          <Grid item sm={6}>
            <InputOptionMaster
              name='pembiayaan'
              label='PEMBIAYAAN'
              id='pembiayaan'
              value={formData.pembiayaan}
              onChange={handleChange("pembiayaan")}
              data={pembiayaanDanPenanggungJawab}
              placeholder=''
            />
          </Grid>
        )}
      </>
    );
  } else {
    return <></>;
  }
};
